import { cn } from '@/lib/utils';
import type { ProfileEmailPillTone } from '../../types';

const PILL_CLASSNAME: Record<ProfileEmailPillTone, string> = {
  warning: 'bg-[#fff1d6] text-[#995206]',
  success: 'bg-[#dff5e7] text-[#216b3c]',
  provider: 'bg-[#e9e3ff] text-[#6741b8]',
};

type ProfileEmailStatusPillProps = {
  tone: ProfileEmailPillTone;
  label: string;
};

export const ProfileEmailStatusPill = ({ tone, label }: ProfileEmailStatusPillProps) => (
  <span
    className={cn(
      'inline-flex min-h-6 items-center rounded-full px-2 py-1 text-[11px] font-bold',
      PILL_CLASSNAME[tone],
    )}
  >
    {label}
  </span>
);
